import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Header, Table, Button, Segment, Icon, Loader } from 'semantic-ui-react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import request from './request';

import StudentAllRegisteredExamsTable from './StudentAllRegisteredExamsTable';

const getGradedActivityTypeName = (type) => ((window.$locale !== 'bs' && type.translations && type.translations.length)
    ? (type.translations.find(e => e.language === window.$locale) ? type.translations.find(e => e.language === window.$locale).name : type.name)
    : type.name);

export default class StudentRegisteredExams extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentId: '',
            studyProgramId: '',
            data: [],
            error: false,
            pastRegisteredExamsData: [],
            pastRegisteredExamsDataLoading: null,
            showPastRegisteredExams: true,
            loading: true,
            cancelingExamId: null,

            gradedActivityTypes: []

        };

        this.cancelExam = this.cancelExam.bind(this);
        this.fetchAllPastRegisteredExams = this.fetchAllPastRegisteredExams.bind(this);
        this.switchPastRegisteredExams = this.switchPastRegisteredExams.bind(this);
    }
    componentDidMount() {
        request.fetchGradedActivityTypes().then(res => {
            this.setState({ gradedActivityTypes: res.data });
        });
        this.fetchRegisteredExams();
        this.fetchAllPastRegisteredExams();
    }

    switchPastRegisteredExams() {
        this.setState(prevState =>
            ({ showPastRegisteredExams: !prevState.showPastRegisteredExams }));
    }
    fetchRegisteredExams() {
        request.fetchExamsToCancel()
            .then(res => {
                this.setState({ data: res.data, loading: false, cancelingExamId: null });
            }).catch(err => {
                toast(<FormattedMessage id="common.error" />);
                this.setState({ error: true });
            });
    }

    fetchAllPastRegisteredExams() {
        request.fetchAllPastRegisteredExams()
            .then(res => {
                this.setState({
                    pastRegisteredExamsData: res.data.sort((a, b) => b.examDate - a.examDate),
                    pastRegisteredExamsDataLoading: false
                });
            }).catch(err => {
                this.setState({
                    pastRegisteredExamsDataLoading: false
                });
            });
    }
    cancelExam(studentGradedActivityId) {
        this.setState({
            cancelingExamId: studentGradedActivityId
        });
        request.cancelExam(studentGradedActivityId)
            .then(res => {
                toast(<FormattedMessage id="student.canceled" />);
                this.fetchRegisteredExams();
            }).catch(err => {
                toast(<FormattedMessage id="common.error" />);
            this.setState({ cancelingExamId: null });
            });
    }
    render() {
        const { pastRegisteredExamsData, data } = this.state;
        return (
            <div>
                <Header as="h1"><FormattedMessage id="student.registeredExams" /></Header>
                {localStorage.getItem('activeRole').substr(0, 8) === 'Student:' && <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3"><FormattedMessage id="student.currentRegisteredExams" /></Header>
                    </Segment>
                    {this.state.loading ? <Segment><div style={{ paddingTop: '20px', paddingBottom: '20px' }}><Loader active inline="centered" /></div></Segment> :
                    <Segment raised>
                            {data.length ?
                            <StudentRegisteredExamsTable data={data} cancelExam={this.cancelExam} gradedActivityTypes={this.state.gradedActivityTypes} cancelingExamId={this.state.cancelingExamId} />
                                : <span><FormattedMessage id="student.noRegisteredExamsMessage" /></span>
                            }
                        </Segment>}
                </Segment.Group>}
                <Segment.Group raised>
                    <Segment raised onClick={this.switchPastRegisteredExams} style={{ cursor: 'pointer' }}>
                        <Header as="h3">
                            <FormattedMessage id="student.allRegisteredExams" />
                            <Header style={{ fontSize: '9px' }} floated="right">
                                <Icon />
                                {this.state.previousRequestMode ? <Icon link circular basic floated="right" name="chevron up" />
                                    : <Icon link circular basic floated="right" name={this.state.showPastRegisteredExams ? 'chevron up' : 'chevron down'} />}
                            </Header>
                        </Header>
                    </Segment>
                    {this.state.loading ? <Segment><div style={{ paddingTop: '20px', paddingBottom: '20px' }}><Loader active inline="centered" /></div></Segment> :
                        this.state.showPastRegisteredExams && <Segment>
                            {pastRegisteredExamsData.length ?
                                <StudentAllRegisteredExamsTable
                                    data={pastRegisteredExamsData}
                                    gradedActivityTypes={this.state.gradedActivityTypes}
                                />
                                : <span><FormattedMessage id="student.noPreviousRegisteredExamsMessage" /></span>
                            }
                        </Segment>}
                </Segment.Group>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}


const StudentRegisteredExamsTable = ({ data, cancelExam, gradedActivityTypes, cancelingExamId }) => (
    <Table tablet stackable celled selectable compact>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell><FormattedMessage id="common.course" /></Table.HeaderCell>
                <Table.HeaderCell><FormattedMessage id="professorInputGrades.examType" />
                    <div style={{
                        fontSize: '0.85em',
                        color: '#999'
                    }}>
                        <FormattedMessage id="professorInputGrades.methodName" />
                    </div>
                </Table.HeaderCell>
                <Table.HeaderCell><FormattedMessage id="professorInputGrades.examDateDate" /></Table.HeaderCell>
                <Table.HeaderCell><FormattedMessage id="common.teacher" /></Table.HeaderCell>
                <Table.HeaderCell><FormattedMessage id="common.classroom" /></Table.HeaderCell>
                <Table.HeaderCell><FormattedMessage id="common.comment" /></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {data.map(row => (
                <Table.Row key={row.gradedActivityId}>
                    <Table.Cell verticalAlign="middle">{row.courseName}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{getGradedActivityTypeName(gradedActivityTypes.find(el => el.id === row.gradedActivityType))}
                        <div style={{
                            fontSize: '0.85em',
                            color: '#999'
                        }}>
                            {row.gradingMethodName ? row.gradingMethodName : ''}
                        </div>
                    </Table.Cell>
                    <Table.Cell verticalAlign="middle">{moment(row.examDate).format('D. M. YYYY. - HH:mm')}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.teacherName}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.classroom}</Table.Cell>
                    <Table.Cell verticalAlign="middle">{row.comment}</Table.Cell>
                    <Table.Cell textAlign="center" verticalAlign="middle">
                        <Button basic="true" color="red"
                                disabled={cancelingExamId}
                                loading={cancelingExamId === row.studentGradedActivityId}
                                onClick={() => cancelExam(row.studentGradedActivityId)}>
                            <FormattedMessage id="student.cancelExam"/>
                        </Button>
                    </Table.Cell>
                </Table.Row>))}
        </Table.Body>
    </Table>
);



// WEBPACK FOOTER //
// ./src/views/StudentRegisterExams/StudentRegisteredExams.js